export default __webpack_public_path__ + "a95c9ea9b935984b646c65c650050423.woff";